import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import MM10080View from "../../Views/Manufacture/MM10080";
import Snackbar from "../../Components/Snackbar";

function MM10080(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [inputs, setInputs] = React.useState({
    ItemCd: "",
    CustItemCd: "",
    ItemNm: "",
    ItemUnit: "",
    ItemStd: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [searchDate, setSearchDate] = React.useState(new Date());
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(monthAgo);
  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (e.message === "ResizeObserver loop limit exceeded") {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let date = startDate;
    console.log(date);
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });

      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10080.GetDayRead,
        {
          startDate: Commons.DateStrChange(startDate),
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
          rowData({});
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.length === 0) {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            if (
              data[i].processNm == "" ||
              data[i].processNm == null ||
              data[i].processNm == "주문" ||
              data[i].processNm == "교정승인단계" ||
              data[i].processNm == "출하"
            ) {
            } else {
              getRowData.push({
                whNm: data[i].whNm, //창고명
                plantNm: data[i].plantNm, //사업장
                processNm: data[i].processNm, //공정명
                machineNm: data[i].machineNm, //설비명
                itemNm: data[i].itemNm, //품명
                itemStd: data[i].itemStd, //규격
                seqQty: data[i].seqQty, //양품수량
                failQty: data[i].failQty, //불량수량
                worker: data[i].worker, //작업자
                processTime: data[i].wkEdDt
                  ? Commons.calculateDateTimeDifference(
                      data[i].wkStDt,
                      data[i].wkEdDt
                    )
                  : null, //작업소요시간
                wkDt: data[i].wkEdDt
                  ? Commons.formatTimeRange(data[i].wkStDt, data[i].wkEdDt)
                  : null, //작업시간
                remark: data[i].remark, //비고
                date:
                  startDate.getFullYear().toString() +
                  "-" +
                  (startDate.getMonth() + 1).toString().padStart(2, "0") +
                  "-" +
                  startDate.getDate(),
              });
            }
          }
          setRowData(Commons.InsertNumber(getRowData));
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <MM10080View
        lanData={lanData}
        rowData={rowData}
        setRowData={setRowData}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        searchDate={searchDate}
        setSearchDate={setSearchDate}
        Init={Init}
        setStartDate={setStartDate}
        startDate={startDate}
      />
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default MM10080;
